<div class="dish-item">
  <div *ngIf="product.isAnyChanged" [class.isAnyChanged]="product.isAnyChanged">*</div>
  <div class="dish-left-part">
    <div class="dish-image" [class.dish-img__default]="!product.externalPictureUrl">
      <img alt="product name" [src]="product.externalPictureUrl ? product.externalPictureUrl : defaultPicture"/>
    </div>
    <div class="dish-info">
      <span [ngClass] = "{'dish-name': true, isDifferent: product.isChangedName}" (click)="onOpenEditProductDialog(product)">{{ product.name }}</span>
      <span class="dish-description">{{ product.description }}</span>
      <div class="dish-price-block" *ngIf="hasPrice">
        <div class="main-dish-right">
          <div class="main-dish-right-price"
               [class.isDifferent]="product.isChangedPrice">
            {{ priceValue | number: '1.2-2' }}
          </div>
        </div>

        <span class="dish-price-currency">{{ currency }}</span>
      </div>
      <div class="size-price" *ngFor="let size of sizes">
        <div class="dish-price-block">
          <div class="main-dish-right">
            <div
              class="main-dish-right-price">
              <span [class.isDifferent]="this.isChangedSize(size.sizeId)">{{ getSizeName(size.sizeId)}}: </span>
              <span [class.isDifferent]="size.isChangedPrice">{{ size.price | number: '1.2-2' }}</span>
            </div>
          </div>
          <span class="dish-price-currency">{{ currency }}</span>
        </div>
      </div>
      <div class="dish-weight-block">
        <div class="dish-item-info__weight">SKU: {{product.sku}}</div>
      </div>
    </div>
  </div>
  <div class="dish-right-part">
    <div *ngIf="showKioskWarning" class="dish-kiosk-warning">
      {{ 'MENU.DISH_NOT_SHOWN_ON_KIOSK' | translate }}
    </div>
    <div class="dish-actions">
      <div class="dish-tags">
        <div class="dish-tag" *ngFor="let tag of product.tags">
          {{ tag }}
        </div>
      </div>

      <div>
        <button mat-icon-button [matMenuTriggerFor]="menu">
          <mat-icon class="dish-more">more_horiz</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="onOpenEditProductDialog(product)">
            <mat-icon>edit</mat-icon>
            <span>{{ "MENU.EDIT" | translate }}</span>
          </button>
          <button mat-menu-item (click)="onOpenMenuEventProductDialog(product)">
            <mat-icon>event</mat-icon>
            <span>{{ "MENU.SHOW_MENU_EVENTS" | translate }}</span>
          </button>
          <button mat-menu-item (click)="onOpenSchedulesProductDialog()">
            <mat-icon>schedule</mat-icon>
            <span>{{ "MENU.SCHEDULES" | translate }}</span>
          </button>
          <button mat-menu-item (click)="onOpenSendProductDialog(product)">
            <mat-icon>send</mat-icon>
            <span>{{ "MENU.SEND_PRODUCT" | translate }}</span>
          </button>
        </mat-menu>
      </div>
    </div>
  </div>
</div>
